const authReducer = (state = {}, action) => {
  switch (action.type) {
    case "SIGN_IN_ERR":
        return {
            ...state,
            authError: action.errorMessage
        };
    case "SIGN_IN":
        //console.log('sign in');
        return {
            ...state,
            authError: null
        };
    case "SIGN_OUT":
        //console.log('sign out success');
        return state;
    default:
      return state; 
  }
};

export default authReducer;
